import React from "react";
import { BCMSDefaultModel, useParams, BCMSRecord, StateManager, useBCMSContext, useRoute, useStateManager } from '@bcm-dev/bcms-vite';
import "./styles.css";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import ReceiveTokenView from "../SecurityTokenPage/components/ReceiveTokenView";
import Classes from "model";

/**
 * @function SecurityTokenReceiveTokenPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SecurityTokenReceiveTokenPage
 * @example
 * <SecurityTokenReceiveTokenPage />
 */
export default function SecurityTokenReceiveTokenPage(props) {
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  const cardID = useParams().cardID ?? "0";
  const data = { ...getDefaultData(cardID), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
  });

return (
  <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
  </StateManager>
);
}

export const getDefaultData = cardID => {
  const cardOnFileMerchant = BCMSDefaultModel.cardOnFileMerchant();

  return {
      cardID,
      cardOnFileMerchant
  };
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, ui } = useStateManager();
  const navigate = useRoute();
  const _data = data ? { data: data } : {};
  const _ui = ui ? { ui: ui } : {};

  return (
    <MainContentContainer 
      className="security-token-page" 
      header={
        <MainContentHeader text="Security Token" onClick={ evt => navigate(`/home/recenttransactions/${ data.cardID }`) } />
      }>
      
      <ReceiveTokenView { ..._data } { ..._ui } />
    </MainContentContainer>
  );
}